/* Enhance the existing Revie widget; leave its data and native navigation intact. */
(() => {
  const roots = new WeakSet();
  const update = root => {
    const track = root.querySelector('.carouselPre');
    if (!track) return;
    const prev = root.querySelector('.rv3-prev');
    const next = root.querySelector('.rv3-next');
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  };
  function init(root) {
    const track = root.querySelector('.carouselPre');
    if (!track) return;
    if (!roots.has(root)) {
      roots.add(root);
      track.id ||= 'HamiltonReviews-' + (root.closest('.shopify-block')?.id || 'home');
      track.tabIndex = 0;
      track.setAttribute('aria-label', 'Opiniones de clientes de Hamilton');
      for (const [selector, label] of [['.rv3-prev','Opiniones anteriores'],['.rv3-next','Opiniones siguientes']]) {
        const button = root.querySelector(selector);
        if (button) { button.setAttribute('aria-label', label); button.setAttribute('aria-controls', track.id); }
      }
      track.addEventListener('scroll', () => update(root), {passive:true});
      track.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const card = track.querySelector('.itemsC');
        track.scrollBy({left:(event.key === 'ArrowRight' ? 1 : -1) * ((card?.offsetWidth || track.clientWidth) + 20), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
    }
    for (const card of track.querySelectorAll('.itemsC')) {
      const copy = card.querySelector('.contents p');
      if (!card.dataset.hamiltonReview) {
      card.dataset.hamiltonReview = 'true';
      const author = copy?.querySelector('b')?.textContent.trim();
      if (card.dataset.go) {
        card.tabIndex = 0;
        card.setAttribute('role', 'link');
        card.setAttribute('aria-label', author ? 'Ver el producto de la opinión de ' + author : 'Ver producto');
        card.addEventListener('keydown', event => { if (event.target === card && event.key === 'Enter') { event.preventDefault(); card.click(); } });
      }
      const stars = card.querySelector('.rv-stars');
      const rating = stars?.style.getPropertyValue('--rating').trim();
      if (stars && rating) { stars.setAttribute('role','img'); stars.setAttribute('aria-label', 'Valoración: ' + rating + ' de 5 estrellas'); }
      }
      const existing = card.querySelector('.hr-read-more');
      const clipped = copy && copy.scrollHeight > copy.clientHeight + 2;
      if (existing && !card.classList.contains('hr-expanded')) existing.hidden = !clipped;
      if (copy && clipped && !existing) {
        copy.id ||= track.id + '-review-' + Array.from(track.children).indexOf(card);
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'hr-read-more'; button.textContent = 'Leer opinión completa'; button.setAttribute('aria-expanded','false'); button.setAttribute('aria-controls',copy.id);
        button.addEventListener('click', event => {
          event.stopPropagation();
          const expanded = card.classList.toggle('hr-expanded');
          button.setAttribute('aria-expanded', String(expanded)); button.textContent = expanded ? 'Ver menos' : 'Leer opinión completa';
        });
        copy.parentElement.append(button);
      }
    }
    update(root);
  }
  const boot = () => document.querySelectorAll('body.template-index .rv3').forEach(init);
  let queued = false;
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; boot(); }); } };
  const start = () => { boot(); const main = document.querySelector('main'); if (main) new MutationObserver(schedule).observe(main,{childList:true,subtree:true}); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  document.addEventListener('shopify:section:load',schedule);
  window.addEventListener('resize',schedule,{passive:true});
  document.fonts?.ready.then(schedule);
})();
